var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "main-content"
  }, [_c('PageHeader', [_c('PageHeaderTitleContent', [_c('TitleTextContent', {
    attrs: {
      "titleText": 'Contact Us'
    }
  })], 1)], 1), _c('section', {
    staticClass: "section contact-area"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row justify-content-center"
  }, [_vm._m(0), _c('div', {
    staticClass: "col-lg-5 col-12"
  }, [_c('div', {
    staticClass: "mt-5"
  }, [_c('b-alert', {
    staticClass: "mt-1",
    attrs: {
      "variant": _vm.dismissableAlertVariant,
      "dismissible": "",
      "fade": "",
      "show": _vm.showDismissibleAlert
    },
    on: {
      "dismissed": function ($event) {
        _vm.showDismissibleAlert = false;
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.dismissableAlertText) + " ")]), _c('h2', {
    staticClass: "pb-4"
  }, [_vm._v("Send us a message")]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('b-form-group', [_c('b-form-input', {
    attrs: {
      "type": "text",
      "name": "name",
      "state": _vm.validateState('name'),
      "aria-describedby": "input-name-feedback",
      "placeholder": "Name"
    },
    model: {
      value: _vm.$v.form.name.$model,
      callback: function ($$v) {
        _vm.$set(_vm.$v.form.name, "$model", $$v);
      },
      expression: "$v.form.name.$model"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "id": "input-name-feedback"
    }
  }, [_vm._v("Please enter a name.")])], 1)], 1), _c('div', {
    staticClass: "col-12"
  }, [_c('b-form-group', [_c('b-form-input', {
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "name": "email",
      "state": _vm.validateState('email'),
      "placeholder": "Email",
      "aria-describedby": "input-email-feedback",
      "required": "required"
    },
    model: {
      value: _vm.$v.form.email.$model,
      callback: function ($$v) {
        _vm.$set(_vm.$v.form.email, "$model", $$v);
      },
      expression: "$v.form.email.$model"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "id": "input-email-feedback"
    }
  }, [_vm._v("Please enter a valid email address.")])], 1)], 1)]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('b-form-group', [_c('b-form-input', {
    attrs: {
      "type": "text",
      "name": "phone",
      "state": _vm.validateState('phone'),
      "value": "",
      "aria-describedby": "input-phonr-feedback",
      "placeholder": "Phone"
    },
    model: {
      value: _vm.$v.form.phone.$model,
      callback: function ($$v) {
        _vm.$set(_vm.$v.form.phone, "$model", $$v);
      },
      expression: "$v.form.phone.$model"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "id": "input-phone-feedback"
    }
  }, [_vm._v("Please enter a phone number.")])], 1)], 1), _c('div', {
    staticClass: "col-12"
  }, [_c('b-form-group', [_c('b-form-input', {
    attrs: {
      "type": "text",
      "name": "organization",
      "state": _vm.validateState('organization'),
      "value": "",
      "size": "40",
      "aria-describedby": "input-organization-feedback",
      "placeholder": "Organization"
    },
    model: {
      value: _vm.$v.form.organization.$model,
      callback: function ($$v) {
        _vm.$set(_vm.$v.form.organization, "$model", $$v);
      },
      expression: "$v.form.organization.$model"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "id": "input-organization-feedback"
    }
  }, [_vm._v("Please enter an organization.")])], 1)], 1)]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('b-form-group', [_c('b-form-textarea', {
    attrs: {
      "name": "message",
      "state": _vm.validateState('message'),
      "rows": "7",
      "placeholder": "How can we help you?"
    },
    model: {
      value: _vm.$v.form.message.$model,
      callback: function ($$v) {
        _vm.$set(_vm.$v.form.message, "$model", $$v);
      },
      expression: "$v.form.message.$model"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "id": "input-organization-feedback"
    }
  }, [_vm._v("Please enter a message.")])], 1)], 1)]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('vue-recaptcha', {
    staticClass: "pb-1",
    attrs: {
      "sitekey": _vm.sitekey,
      "loadRecaptchaScript": true
    },
    on: {
      "verify": _vm.verifyMethod,
      "expired": _vm.expiredMethod,
      "render": _vm.renderMethod,
      "error": _vm.errorMethod
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": _vm.captchaValidated
    }
  }, [_vm._v(" Please complete the captcha by selecting the checkbox. ")]), _c('button', {
    staticClass: "btn theme-btn w-100 rounded mt-1",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v(" Send Message ")])], 1)])], 1)])])])])], 1);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "col-lg-7 col-12"
  }, [_c('div', {
    staticClass: "contact-main form-box"
  }, [_c('div', {
    staticClass: "contact-inner z-index9"
  }, [_c('div', {
    staticClass: "section-title"
  }, [_c('h2', {
    staticClass: "text-white"
  }, [_vm._v("Let's Connect")])]), _c('div', {
    staticClass: "contact-address mt-5"
  }, [_c('h2', {
    staticClass: "text-white"
  }, [_vm._v("About Us")]), _c('div', {
    staticClass: "address mt-2"
  }, [_c('p', {
    staticClass: "text-white"
  }, [_vm._v(" Project Spectrum is a comprehensive, cost-effective platform that provides companies, institutions, and organizations with cybersecurity information, resources, tools, and training. Our mission is to improve cybersecurity readiness, resiliency, and compliance for small/medium-sized businesses and the federal manufacturing supply chain. ")])])]), _c('div', {
    staticClass: "contact-email mt-5"
  }, [_c('h2', {
    staticClass: "text-white"
  }, [_vm._v("Training Inquiries")]), _c('div', {
    staticClass: "address text-white mt-2"
  }, [_c('p', [_vm._v("For training inquiries, please contact")]), _c('a', {
    staticClass: "link-white",
    attrs: {
      "href": "mailto:outreach@projectspectrum.io"
    }
  }, [_vm._v("outreach@projectspectrum.io")])])]), _c('div', {
    staticClass: "contact-email mt-5"
  }, [_c('h2', {
    staticClass: "text-white"
  }, [_vm._v("Site Support")]), _c('div', {
    staticClass: "address text-white mt-2"
  }, [_c('p', [_vm._v("For help with this website, please contact")]), _c('a', {
    staticClass: "link-white",
    attrs: {
      "href": "mailto:support@projectspectrum.io"
    }
  }, [_vm._v("support@projectspectrum.io")])])]), _c('div', {
    staticClass: "social-media-transparent mt-5"
  }, [_c('ul', {
    staticClass: "social-links list-unstyled d-flex justify-content-start"
  }, [_c('li', {
    staticClass: "linkedin"
  }, [_c('a', {
    attrs: {
      "href": "https://www.linkedin.com/showcase/project-spectrum/",
      "title": "Linkedin",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "mdi mdi-linkedin font-20"
  })])]), _c('li', {
    staticClass: "youtube"
  }, [_c('a', {
    attrs: {
      "href": "https://www.youtube.com/channel/UCHU-4dUkYInJhpabvW6Ps1g/videos",
      "title": "Youtube",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "mdi mdi-youtube font-20"
  })])])])])])])]);

}]

export { render, staticRenderFns }